import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: ${props => (props.theme.title === 'light' ? '#fff' : '#2A2A3D')};
  border: none;
  border-radius: 5px;

  .title {
    height: 30px;
    width: 100%;
    border-bottom: 1px solid black;

    p {
      font-size: 16px;
      margin-left: 10px;
      color: ${props =>
        props.theme.title === 'light' ? '#7a7a7a' : '#fff'} !important;
    }
  }

  .buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30vh;
    gap: 20px;

    button {
      text-transform: unset !important;
      font-family: 'Poppins', sans-serif;
      font-weight: 600;
      font-size: 12px;
      padding: 10px 25px;
      border-radius: 6px;
      box-shadow: none;
      height: 40px;
      p {
        margin-left: 9px;
      }
      &:hover {
        transition: 0.5s;
        box-shadow: none;
      }
    }
    .importButton {
      background-color: ${props =>
        props.theme.title === 'dark' ? '#212E48' : '#ecf8ff'};
      color: #0095e8;

      path {
        fill: #0095e8;
      }
      &:hover {
        background-color: #3fbaff;
        transition: 0.5s;
        box-shadow: none;
        p {
          color: #ffffff !important;
        }
        path {
          fill: #ecf8ff;
        }
      }
    }
    .saveButton {
      background-color: ${props =>
        props.theme.title === 'light' ? '#50cd89' : '#1C3238'};
      color: ${props => (props.theme.title === 'light' ? '#fff' : '#04aa77')};
      path {
        fill: ${props => (props.theme.title === 'light' ? '#fff' : '#04aa77')};
      }
      padding: 13px 16px;
      &:hover {
        background-color: ${props =>
          props.theme.title === 'light' ? '#50cd55' : '#50cd89'};
        color: #fff;
        path {
          fill: #e8fff3;
        }
      }
      &:disabled {
        background-color: #0095e8;
        opacity: 0.6;
      }
    }
    .clearButton {
      background-color: ${props =>
        props.theme.colors.tagStatusColors.finalizado_divergente_or_bloqueado
          .bg};
      color: ${props =>
        props.theme.colors.tagStatusColors.finalizado_divergente_or_bloqueado
          .color};
      padding: 13px 16px;
      &:hover {
        background-color: #f1416c;
        color: #fff5f8;
        path {
          fill: #fff5f8 !important;
        }
      }
    }
    .popUp {
      margin-right: 10px;
    }

    @media screen and (max-width: 600px) {
      justify-content: center;
      gap: 8px;
      flex-direction: column;
      padding: 8px;
      & > .MuiButtonBase-root {
        width: 100%;
      }
    }
  }
`;

export const StyledInput = styled.input`
  background: transparent;
  border: 1px solid
    ${props => (props.theme.title === 'light' ? '#7a7a7a' : '#fff')} !important;
  color: ${props => (props.theme.title === 'light' ? '#7a7a7a' : '#fff')};
  border-radius: 5px;
  padding: 8px;
  font-size: 16px;
  height: 30px;
  outline: none;
  appearance: none;
  box-sizing: border-box;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    border-color: #007bff !important;
    appearance: none;
  }

  &:disabled {
    opacity: 0.6; /* Adjust opacity as needed */
    cursor: not-allowed;
  }
`;

export const InputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;
